// Assume jquery exists in the window. This should be true for wordpress.
const jQuery = (window as any).jQuery as JQuery;
const jQueryStatic = (window as any).jQuery as JQueryStatic;
export { jQuery, jQueryStatic };
